
import { LockedArt } from '@/components/illustrations';
import { Button, Card, CardContent } from '@/components/cargofl-ui';
import { useSignOut } from '@/lib/session';

/**
 * Signed in successfully, but the employee record has no department or no reporting
 * manager, so goals cannot be assigned and no assessment can be reviewed.
 *
 * Distinct from "access denied" on purpose: nothing is wrong with this person's
 * credentials or permissions, and the fix is a request to HR rather than another
 * sign-in attempt. Telling them to "check their permissions" would send them
 * chasing the wrong thing.
 */
export function NotOnboardedPage() {
  const signOut = useSignOut();

  return (
    <div className="flex min-h-dvh items-center justify-center p-6">
      <Card className="w-full max-w-md">
        <CardContent className="space-y-5 py-10 sm:py-10">
          <LockedArt className="-ml-2 h-20 w-auto" />

          <div className="space-y-2">
            <h1 className="text-xl font-bold tracking-[-0.01em]">You are not set up yet</h1>
            <p className="text-sm text-muted-foreground">
              You signed in successfully, but your record is missing a department or a reporting
              manager. HR needs to assign those before goals can be set for you or your assessments
              can be reviewed.
            </p>
          </div>

          <div className="rounded-md bg-muted p-3 text-sm">
            <p className="font-medium">What to do</p>
            <p className="mt-1 text-muted-foreground">
              Ask HR to add you, then sign in again. Nothing is wrong with your account.
            </p>
          </div>

          <Button variant="outline" onClick={() => void signOut()}>
            Sign out
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
